"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _emotion = require("emotion");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _thumbnail = _interopRequireDefault(require("@amzn/meridian-tokens/component/thumbnail"));

var _theme = require("../theme");

var _filterPropsByPrefix = _interopRequireDefault(require("./../_utils/filter-props-by-prefix"));

var styles = function styles(t, _ref) {
  var size = _ref.size,
      backgroundColor = _ref.backgroundColor,
      borderColor = _ref.borderColor,
      type = _ref.type,
      source = _ref.source;
  var borderSize = type === "circular" ? size : undefined;
  return (0, _emotion.css)({
    width: t("size", size),
    height: t("size", size),
    position: "relative",
    backgroundColor: backgroundColor,
    borderColor: borderColor,
    borderRadius: t("border", [type, "radius", borderSize]),
    borderStyle: borderColor ? "solid" : "undefined",
    borderWidth: borderColor ? t("borderWidth") : undefined,
    overflow: "hidden",
    backgroundImage: "url(".concat(source, ")"),
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    backgroundSize: "cover"
  });
};
/**
 * @since 4.x
 */


var Thumbnail = function Thumbnail(props) {
  var source = props.source,
      backgroundColor = props.backgroundColor,
      borderColor = props.borderColor,
      label = props.label,
      size = props.size,
      type = props.type;
  var t = (0, _theme.useTheme)(_thumbnail["default"], "thumbnail");
  var passThroughProps = (0, _filterPropsByPrefix["default"])(props, ["data-", "aria-"]);
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({}, passThroughProps, {
    role: "img" // TODO: deprecate label prop in 6.x
    ,
    "aria-label": label,
    className: (0, _emotion.cx)(styles(t, {
      size: size,
      backgroundColor: backgroundColor,
      borderColor: borderColor,
      type: type,
      source: source
    }))
  })));
};

Thumbnail.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Source for the thumbnail image.
   *
   * Accepts either a reference to a locally packaged
   * asset file, or a URI to an externally hosted asset.
   */
  source: _propTypes["default"].string.isRequired,

  /**
   * All props prefixed with `aria-` are accepted. This is useful for adding [aria
   * attributes](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) for improved accessibility.
   *
   * @since 5.30.0
   */
  "aria-*": _propTypes["default"].string,

  /**
   * Set the thumbnails background color using  a string
   * containing any valid CSS color.
   */
  backgroundColor: _propTypes["default"].string,

  /**
   * Set the thumbnails border color using  a string
   * containing any valid CSS color.
   */
  borderColor: _propTypes["default"].string,

  /**
   * All props prefaced with `data-` are accepted. This is useful for
   * integrating with other libraries such as Amplify Analytics or Cypress.
   *
   * @since 5.30.0
   */
  "data-*": _propTypes["default"].string,

  /**
   * NOTE: This is deprecated and will be removed in 6.x, use `aria-label` instead.
   *
   * @deprecated 5.30.0
   */
  label: _propTypes["default"].string,

  /**
   * Sets the size of the component using a preset.
   */
  size: _propTypes["default"].oneOf(["small", "medium", "large"]),

  /**
   * This determines the visual style and masking of
   * the thumbnail.
   */
  type: _propTypes["default"].oneOf(["circular", "square"])
} : {};
Thumbnail.defaultProps = {
  size: "medium",
  type: "circular"
};
var _default = Thumbnail;
exports["default"] = _default;